<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recipient Death EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="causeOfDeathCategory"
              class="causeOfDeathCategory"
              disabled
              label="Cause of Death Category"
            />
          </div>

          <div v-if="causeOfDeathCategory?.toLowerCase() !== 'other'" class="col-3">
            <ADSTextInput
              v-model="causeOfDeathType"
              class="causeOfDeathType"
              disabled
              label="Cause of Death Type"
            />
          </div>


          <div v-if="causeOfDeathCategory?.toLowerCase() === 'other'" class="col-2">
            <ADSTextInput
              v-model="causeOfDeathTypeOther"
              disabled
              label="Cause of Death Type Other"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="deathDate"
              disabled
              label="Death Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "RecipientDeathSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      causeOfDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
      causeOfDeathType: this.getCauseDeathType( this.patientBundle ),
      causeOfDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
      deathDate: this.getDeathDate( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getCauseDeathCategory( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4098' );
    },
    getCauseDeathType( patientBundle ) {
      const causeOfDeathTypeCodes = [
        'UHN#3842', 'UHN#3843', 'UHN#3844', 'UHN#3845', 'UHN#3846', 'UHN#3847', 'UHN#3848',
        'UHN#3849', 'UHN#3850', 'UHN#3851', 'UHN#3852', 'UHN#3853', 'UHN#3854',
      ];

      for( const code of causeOfDeathTypeCodes ) {
        const value = this.getSmartdataComponentValue( patientBundle, code );
        if( value !== null ) {
          return value;
        }
      }

      return null;
    },
    getCauseDeathTypeOther( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3832' );
    },
    getDeathDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#3968', 'valueDateTime' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 260px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 260px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayCauseDeathType {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayComments {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.causeOfDeathType .afflo-ds-form-control) {
  width: 330px;
}

:deep(.causeOfDeathCategory .afflo-ds-form-control) {
  width: 330px;
}

:deep(.comments .afflo-ds-form-control) {
  width: 400px;
}

</style>
